<template>
	<p v-tw-class="'text-body-min/base-max'">
		<slot />
	</p>
</template>
